var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcEventNoteEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "fhxv51tyfa",
    d: "M14.167 8.333H5.833V10h8.334V8.333zM15.833 2.5H15V.833h-1.667V2.5H6.667V.833H5V2.5h-.833c-.925 0-1.659.75-1.659 1.667L2.5 15.833c0 .917.742 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V4.167c0-.917-.75-1.667-1.667-1.667zm0 13.333H4.167V6.667h11.666v9.166zm-4.166-4.166H5.833v1.666h5.834v-1.666z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0dy7rw21sb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fhxv51tyfa"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2565C7",
    mask: "url(#0dy7rw21sb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H41.667V41.667H0z",
    transform: "translate(-10.833 -10.833)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcEventNoteEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-event-note-edit.a310cb60.svg";
export { ForwardRef as ReactComponent };